import I18n from "../../I18n";
import { alias, format } from "../../utils";
import * as mappers from "../mappers";

export const checkForCustomFragment = (mappers, modulePrefix, entity) => {
    if (
        modulePrefix &&
        mappers[`${modulePrefix}`] &&
        mappers[`${modulePrefix}`][`${entity.toLowerCase()}Mapper`]
    ) {
        return true;
    }
    return false;
};

const fetch = (state = { results: {}, status: {}, activity: null }, action) => {
    switch (action.type) {
        case "FETCH_QUERIES_START": {
            const result = JSON.parse(JSON.stringify(state));
            const queries = action.payload;
            queries.forEach((query) => {
                const isDatagridReq = query.isDatagridReq;
                const statusKey = alias(
                    {
                        ...query,
                        locale: action.locale,
                    },
                    true,
                    null,
                    isDatagridReq,
                );
                const statusPagging = (
                    result.status[statusKey] || { pagging: [undefined, undefined] }
                ).pagging;
                result.status[statusKey] = {
                    ...(result.status[statusKey] || {}),
                    loading: true,
                    pagging: [(query.args || {}).page, statusPagging[1], statusPagging[2]],
                };
            });
            return {
                ...result,
                activity: true,
            };
        }
        case "FETCH_QUERIES_REJECT": {
            const result = JSON.parse(JSON.stringify(state));
            const queries = action.payload;

            queries.forEach((query) => {
                const isDatagridReq = query.isDatagridReq;
                const statusKey = alias(
                    {
                        ...query,
                        locale: action.locale,
                    },
                    true,
                    null,
                    isDatagridReq,
                );
                result.status[statusKey] = {
                    ...(result.status[statusKey] || {}),
                    loading: false,
                };
            });
            return {
                ...result,
                activity: false,
            };
        }
        case "FETCH_QUERIES_SUCCESS": {
            const result = JSON.parse(JSON.stringify(state));
            result.activity = false;
            const { data, queries } = action.payload;
            const now = Date.now();

            let getModulesAvailableByProject = [];
            // TODO: add append logic - fetchAction should set if data is to append or not
            const findIndexOfModulesResource = queries.findIndex(
                (elem) => elem["resource"] === "project_modules",
            );
            if (findIndexOfModulesResource > -1) {
                const tempResource = queries[findIndexOfModulesResource];
                queries.splice(findIndexOfModulesResource, 1);
                queries.unshift(tempResource);
            }
            queries.forEach((query) => {
                const isDatagridReq = query.isDatagridReq;
                const queryAlias = alias(
                    {
                        ...query,
                        locale: action.locale,
                    },
                    null,
                    null,
                    isDatagridReq,
                );
                const statusKey = alias(
                    {
                        ...query,
                        locale: action.locale,
                    },
                    true,
                    null,
                    isDatagridReq,
                );

                const modulePrefix = (query.args || {}).modulePrefix;
                const queryData = data[queryAlias];

                if (result.results[queryAlias]) {
                    if (result.results[queryAlias]["modules"]) {
                        getModulesAvailableByProject = result.results[queryAlias]["modules"];
                    }
                }
                if (queryData) {
                    result.status[statusKey] = {
                        success: true,
                        loading: false,
                        lastReadTime: Object.keys(queryData).length
                            ? now
                            : (result.status[statusKey] || {}).lastReadTime,
                        resultKey: queryAlias,
                        pagging: [(query.args || {}).page, (query.args || {}).pageSize],
                    };
                    if (
                        Array.isArray(queryData) ||
                        (queryData && queryData.hasMore !== undefined)
                    ) {
                        const items = queryData.items || queryData;
                        const headerItems = queryData.headerItems || [];
                        const entity =
                            (items[0] || {}).__typename ||
                            (queryData.__typename || "").replace(/s?Response$/, "") ||
                            "";

                        const mapper =
                            checkForCustomFragment(mappers, modulePrefix, entity) &&
                            entity.toLowerCase() !== "genericview"
                                ? mappers[`${modulePrefix}`][`${entity.toLowerCase()}Mapper`]
                                : mappers[`${entity.toLowerCase()}Mapper`];
                        const currentList =
                            query.append &&
                            result.results[queryAlias] &&
                            result.results[queryAlias].list
                                ? result.results[queryAlias].list
                                : [];
                        if (entity && mapper) {
                            const concatedList = [
                                ...currentList,
                                ...items.map((json) =>
                                    mapper.map(
                                        json,
                                        true,
                                        false,
                                        action.locale,
                                        queryData.entity,
                                        getModulesAvailableByProject,
                                        queryData.kpis,
                                    ),
                                ),
                            ];

                            result.results[queryAlias] = {
                                header:
                                    typeof mapper.header === "function"
                                        ? mapper.header(
                                              headerItems,
                                              getModulesAvailableByProject,
                                              // Not to override the existing align coming from the database
                                              isDatagridReq,
                                          )
                                        : mapper.header,
                                list: concatedList,
                                filters:
                                    mapper && mapper.mapFilters
                                        ? mapper.mapFilters(queryData.filters)
                                        : queryData.filters,
                                footer: [
                                    queryData.total
                                        ? I18n.translate`${format(
                                              concatedList.length,
                                              "normal",
                                              null,
                                          )} of ${format(queryData.total, "normal", null)}`
                                        : "",
                                ],
                                totalizers: queryData.totalizers,
                                metadata: {
                                    summary: queryData.summary,
                                    hasMore: queryData.hasMore,
                                    total: queryData.total,
                                },
                                exportableEntities: queryData.exportableEntities,
                                xlsxLabels: queryData.xlsxLabels,
                                showDetailPanel: mapper?.showDetailPanel || false,
                                showCheckbox: mapper?.showCheckbox || false,
                            };
                        } else {
                            const concatedList = [...currentList, ...items];
                            result.results[queryAlias] = {
                                ...(result.results[queryAlias] || {}),
                                filters:
                                    mapper && mapper.mapFilters
                                        ? mapper.mapFilters(queryData.filters)
                                        : queryData.filters,
                                footer: [
                                    queryData.total
                                        ? I18n.translate`${format(
                                              concatedList.length,
                                              "normal",
                                              null,
                                          )} of ${format(queryData.total, "normal", null)}`
                                        : "",
                                ],
                                totalizers: queryData.totalizers,
                                metadata: {
                                    summary: queryData.summary,
                                    hasMore: queryData.hasMore,
                                    total: queryData.total,
                                },
                                list: concatedList,
                                exportableEntities: queryData.exportableEntities,
                                xlsxLabels: queryData.xlsxLabels,
                                showDetailPanel: mapper?.showDetailPanel || false,
                                showCheckbox: mapper?.showCheckbox || false,
                            };
                        }
                    } else if (
                        queryData.lines &&
                        (Array.isArray(queryData.lines) ||
                            (queryData.lines && queryData.lines.hasMore !== undefined))
                    ) {
                        const items = queryData.lines.items || queryData.lines;
                        const entity =
                            (items[0] || {}).__typename ||
                            (queryData.lines.__typename || "").replace(/s?Response$/, "") ||
                            "";
                        const mapper = checkForCustomFragment(mappers, modulePrefix, entity)
                            ? mappers[`${modulePrefix}`][`${entity.toLowerCase()}linesMapper`]
                            : mappers[`${entity.toLowerCase()}linesMapper`];
                        const currentList =
                            query.append &&
                            result.results[queryAlias] &&
                            result.results[queryAlias].list
                                ? result.results[queryAlias].list
                                : [];
                        if (entity && mapper) {
                            const concatedList = [
                                ...currentList,
                                ...items.map((json) =>
                                    mapper.map(json, true, false, action.locale),
                                ),
                            ];

                            const others = Object.keys(queryData)
                                .filter((key) => !["lines"].includes(key))
                                .reduce((obj, key) => {
                                    obj[key] = queryData[key];
                                    return obj;
                                }, {});

                            result.results[queryAlias] = {
                                others,
                                header: mapper.header,
                                list: concatedList,
                                filters:
                                    mapper && mapper.mapFilters
                                        ? mapper.mapFilters(queryData.lines.filters)
                                        : queryData.lines.filters,
                                footer: [
                                    queryData.lines.total
                                        ? I18n.translate`${format(
                                              concatedList.length,
                                              "normal",
                                              null,
                                          )} of ${format(queryData.lines.total, "normal", null)}`
                                        : "",
                                ],
                                totalizers: queryData.totalizers,
                                metadata: {
                                    hasMore: queryData.lines.hasMore,
                                    total: queryData.lines.total,
                                },
                                exportableEntities: queryData.exportableEntities,
                                xlsxLabels: queryData.xlsxLabels,
                                showDetailPanel: mapper?.showDetailPanel || false,
                                showCheckbox: mapper?.showCheckbox || false,
                            };
                        } else {
                            const concatedList = [...currentList, ...items];
                            result.results[queryAlias] = {
                                ...(result.results[queryAlias] || {}),
                                filters:
                                    mapper && mapper.mapFilters
                                        ? mapper.mapFilters(queryData.filters)
                                        : queryData.filters,
                                footer: [
                                    queryData.total
                                        ? I18n.translate`${format(
                                              concatedList.length,
                                              "normal",
                                              null,
                                          )} of ${format(queryData.total, "normal", null)}`
                                        : "",
                                ],
                                totalizers: queryData.totalizers,
                                metadata: {
                                    hasMore: queryData.hasMore,
                                    total: queryData.total,
                                },
                                list: concatedList,
                                exportableEntities: queryData.exportableEntities,
                                xlsxLabels: queryData.xlsxLabels,
                                showDetailPanel: mapper?.showDetailPanel || false,
                                showCheckbox: mapper?.showCheckbox || false,
                            };
                        }
                    } else if (
                        queryData[`${modulePrefix || ""}_lines`] &&
                        (Array.isArray(queryData[`${modulePrefix || ""}_lines`]) ||
                            (queryData[`${modulePrefix || ""}_lines`] &&
                                queryData[`${modulePrefix || ""}_lines`].hasMore !== undefined))
                    ) {
                        const items =
                            queryData[`${modulePrefix || ""}_lines`].items ||
                            queryData[`${modulePrefix || ""}_lines`];
                        const entity =
                            (items[0] || {}).__typename ||
                            (queryData[`${modulePrefix || ""}_lines`].__typename || "").replace(
                                /s?Response$/,
                                "",
                            ) ||
                            "";
                        const mapper =
                            modulePrefix && mappers[`${modulePrefix}`]
                                ? mappers[`${modulePrefix}`][`${entity.toLowerCase()}linesMapper`]
                                : mappers[`${entity.toLowerCase()}linesMapper`];
                        const currentList =
                            query.append &&
                            result.results[queryAlias] &&
                            result.results[queryAlias].list
                                ? result.results[queryAlias].list
                                : [];
                        if (entity && mapper) {
                            const concatedList = [
                                ...currentList,
                                ...items.map((json) =>
                                    mapper.map(json, true, false, action.locale),
                                ),
                            ];

                            const others = Object.keys(queryData)
                                .filter((key) => !["lines"].includes(key))
                                .reduce((obj, key) => {
                                    obj[key] = queryData[key];
                                    return obj;
                                }, {});

                            result.results[queryAlias] = {
                                others,
                                header: mapper.header,
                                list: concatedList,
                                filters:
                                    mapper && mapper.mapFilters
                                        ? mapper.mapFilters(
                                              queryData[`${modulePrefix || ""}_lines`].filters,
                                          )
                                        : queryData[`${modulePrefix || ""}_lines`].filters,
                                footer: [
                                    queryData[`${modulePrefix || ""}_lines`].total
                                        ? I18n.translate`${format(
                                              concatedList.length,
                                              "normal",
                                              null,
                                          )} of ${format(
                                              queryData[`${modulePrefix || ""}_lines`].total,
                                              "normal",
                                              null,
                                          )}`
                                        : "",
                                ],
                                totalizers: queryData.totalizers,
                                metadata: {
                                    hasMore: queryData[`${modulePrefix || ""}_lines`].hasMore,
                                    total: queryData[`${modulePrefix || ""}_lines`].total,
                                },
                                exportableEntities: queryData.exportableEntities,
                                xlsxLabels: queryData.xlsxLabels,
                                showDetailPanel: mapper?.showDetailPanel || false,
                                showCheckbox: mapper?.showCheckbox || false,
                            };
                        } else {
                            const concatedList = [...currentList, ...items];
                            result.results[queryAlias] = {
                                ...(result.results[queryAlias] || {}),
                                filters:
                                    mapper && mapper.mapFilters
                                        ? mapper.mapFilters(queryData.filters)
                                        : queryData.filters,
                                footer: [
                                    queryData.total
                                        ? I18n.translate`${format(
                                              concatedList.length,
                                              "normal",
                                              null,
                                          )} of ${format(queryData.total, "normal", null)}`
                                        : "",
                                ],
                                totalizers: queryData.totalizers,
                                metadata: {
                                    hasMore: queryData.hasMore,
                                    total: queryData.total,
                                },
                                list: concatedList,
                                exportableEntities: queryData.exportableEntities,
                                xlsxLabels: queryData.xlsxLabels,
                                showDetailPanel: mapper?.showDetailPanel || false,
                                showCheckbox: mapper?.showCheckbox || false,
                            };
                        }
                    } else {
                        if (typeof queryData === "object" && queryData !== null) {
                            if (queryData["modules"]) {
                                getModulesAvailableByProject = queryData["modules"];
                            }
                        }
                        const entity = (queryData || {}).__typename || "";

                        const mapper =
                            modulePrefix &&
                            checkForCustomFragment(mappers, modulePrefix, entity) &&
                            entity.toLowerCase() !== "genericview"
                                ? mappers[`${modulePrefix}`][`${entity.toLowerCase()}Mapper`]
                                : mappers[`${entity.toLowerCase()}Mapper`];

                        if (mapper) {
                            result.results[queryAlias] = mapper.map(
                                queryData,
                                false,
                                true,
                                action.locale,
                                queryData.entity,
                                getModulesAvailableByProject,
                                queryData.kpis,
                            );
                        } else {
                            result.results[queryAlias] = queryData;
                        }
                    }
                } else {
                    result.status[statusKey] = {
                        ...(result.status[statusKey] || {}),
                        resultKey: queryAlias,
                        loading: false,
                        pagging: [(query.args || {}).page, (query.args || {}).pageSize],
                    };
                }
            });

            return result;
        }
        case "LOGOUT_SUCCESS": {
            return { results: {}, status: {}, activity: false };
        }
        default:
            break;
    }
    return state;
};

export default fetch;
